import React, { useState, useEffect } from "react";
import { Crud_Catalogos } from '../../../../herramientas/Crud_Catalogos';
import { VincularDispositivo, PlantillasWhatsApp } from ".";

const WhatsApp =({ elementos, stor })=> {
  const [whatsappConfiguracion, setWhatsappConfiguracion]= useState({});
  const [tab, setTab]= useState(1);

  useEffect(() => {
    getfuntion("get", "", "", "whatsapp_configuracion/plataforma/"+elementos.id,"whatsapp_configuracion");
  }, []);

  const getfuntion = (metodo="get", obj=[], id="", catalogo="", stateVar= "", hiddenModl="") =>{
    return Crud_Catalogos(catalogo, "correoPlantillas", metodo, id, obj,"" , stateVar, hiddenModl, []).then((returnVal) => {
        switch (metodo) {
          case "get":
            if( stateVar === "whatsapp_configuracion"){
              setWhatsappConfiguracion(returnVal);
            }
            break;
          default:
            break;
        }
      }).catch(err =>{ console.log("Error desconocido ....");  })
  }
  
  return (
    <div>
      {/**
       <WhatsApp
        accion={ this.props.accion }
        elementos= { this.props.elementos }
        getfuntion= { this.props.getfuntion}
        stor= { this.props.stor }
        getCorreoPlataforma={ this.state.correoPlataforma }
        />
       */}
      { whatsappConfiguracion.id?
        <div>
          <div className="row">
            <div className="col">
              <div className="row">
                <div className="col"></div>
                  <div className="col">
                    <ul className="nav nav-tabs">
                      <li className="nav-item">
                        <a className={"nav-link"+ (tab === 1 ? " active":"")} onClick={()=> setTab(1)}>Info</a>
                      </li>
                      <li className="nav-item">
                        <a className={"nav-link"+ (tab === 2 ? " active":"")} onClick={()=>{ setTab(2) }} > Vincular dispositivo</a>
                      </li>
                      <li className="nav-item">
                        <a className={"nav-link"+ (tab === 3 ? " active":"")} onClick={()=>{ setTab(3) }}> Plantillas</a>
                      </li>
                    </ul>
                </div>
                <div className="col"></div>
              </div>
              <div  hidden={tab !== 1}>
                <h4>Información</h4>
                <ul className="list-group list-group-flush mt-8">
                  <li className="list-group-item">
                    <span className="float-left">Intancia</span>
                    <span className="float-right">{whatsappConfiguracion.intanciaId}</span>
                  </li>
                  <li className="list-group-item">
                    <span className="float-left">Teléfono</span>
                    <span className="float-right">{whatsappConfiguracion.telefono}</span>
                  </li>
                  <li className="list-group-item">
                    <span className="float-left">Campaña</span>
                    <span className="float-right">{whatsappConfiguracion.campaign}</span>
                  </li>
                </ul>
              </div>
              <div  hidden={tab !== 2}>
                <VincularDispositivo  whatsappConfiguracion= {whatsappConfiguracion}/>
              </div>
              <div  hidden={tab !== 3}>
                <PlantillasWhatsApp
                  stor= { stor }
                  plataforma= { elementos }
                  whatsappConfiguracion= { whatsappConfiguracion }
                />
              </div>
            </div>
          </div>
        </div>
        :
          <div>
            <h3> Esta plataforma no se encuentra configurada para envio de whatsApp</h3>
          </div>
      }
          
    </div>
  )
}

export default WhatsApp
